module.exports = __webpack_public_path__ + "img/slide6.884246c9.png";